import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import { toggleClass } from '../utils/dom'

export const STATES = {
    COMPLETED: 'is-completed'
}

export default class CourseSection extends Component {
    prepare() {
        CourseState.on('change', this.handleStateChange)
        this.render(CourseState.state)
    }

    handleStateChange = state => {
        this.render(state)
    }

    render(state) {
        const lessons = Object.entries(state.lessons).map(entry => entry[1])
        const completed = lessons.filter(lesson => lesson.completed).length
        const total = lessons.length

        toggleClass(this.element, STATES.COMPLETED, completed === total)
    }
}